/*
 * File: phone.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on May 18, 2025 at 11:24 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: July 31, 2025 at 9:58 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import { parsePhoneNumber } from 'libphonenumber-js/max';


/**
 * Utilities
 */

export const formatPhoneNumber = (number) => {
	try {

		// Attempt to parse phone number
		const phoneNumber = parsePhoneNumber(number);

		// Format number
		let formatted = phoneNumber.formatNational();

		// Format toll free
		if (phoneNumber.country === 'US' && ['800', '833', '844', '855', '866', '877', '888'].some((n) => phoneNumber.number.startsWith(`+1${n}`))) {

			// Break up number
			const components = formatted.split(')').map((p) => p.trim().replace('(', ''));

			// Build number
			formatted = `1-${components[0]}-${components[1]}`;

		} else if (phoneNumber.country === 'JP' && ['120', '570'].some((n) => phoneNumber.number.startsWith(`+81${n}`))) {

			// Return formatted number
			return formatted;
		}

		// Return formatted number
		return formatted;

	} catch (_) {}

	// Return number
	return number;
};
